export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#B48747',
    light: '#F6F6F6',
  },
  secondary: {
    main: '#FFFFFF',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    brand: '#9D7236',
    primary: '#171616',
    secondary: '#585858',
    tertiary: '#D0BA9A',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    link: '#358CD9',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    fill: '#E5D8CC',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#171616',
    footer: '#171616',
    discount: '#DBC4B5',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#171616',
    tableSubhead: '#FBFBFB',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: 'linear-gradient(132.17deg, #B48747 -280.65%, #000000 80.65%)',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E9EDEF80',
    secondary: '#F8D859',
    light: '#FBFBFB',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    border: '#EBEBEB',
  },
  surface: {
    grey: '#F9F9F9',
    savings: '#E1F0FF',
    light: '#F1F1F1',
    alternate: '#AD8851',
    header: '#F1F7FE',
    pricing: 'linear-gradient(291.46deg, #171717 -0.12%, #171717 114.59%)',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
